 /* eslint-disable no-use-before-define ,no-dupe-keys, no-mixed-spaces-and-tabs , jsx-a11y/label-has-associated-control,object-shorthand */


import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'components_newui/Loading';
import ModeToggle from './components/ModeToggle';
import TaggedIdeaList from './components/TaggedIdeaList';
import ChallengeSelect from './components/ChallengeSelect';
import IdeaDropdownWithSearch from './components/IdeaDropdownWithSearch';
  

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        alignItems: 'center',
        background: '#fff',
        display: 'flex',
        fontFamily: 'VodafoneRg-Regular',
        justifyContent: 'center',
        minHeight: '80vh',
        padding: '20px'
    },
    card: {
        background: '#fff',
        border: '1px solid #e1e5e9',
        borderRadius: '1rem',
        boxShadow: '0 4px 20px rgba(0, 0, 0, .08)',
        maxWidth: '620px',
        padding: '4rem',
        width: '100%',
    },
    wrp: {
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title: {
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '1.25rem',
        margin: '0 0 2rem 0',
        textAlign: 'left',
        color: "#333",
    },
})
);




const AdminRemoveEvaluator = (props) => {
    const history = useHistory()
    const classes = useStyles()
    const {  userEmail,getInnovateChallengeFilterListFn,onDeteleSpecificIdeaListFromChallengeFn, postAfterIdeaListRemoveEvalutorIsLoading, getListIdeaListRemoveEvalutorIsLoading, postReponseDataForSpecificIdeaList, getInnovateIdeaListFromChallenge, getIdeaListFromChallengeFn, challengesListIsLoading, postAfterRemoveEvalutorIsLoading, getInnovateChallengeAllListForRemoveEvaluatorFn, deleteAssignedEvaluatorIntoChallengeFn, postAdminRemoveEvaluatorIsLoading, listInnovateChallengeForEvalutor, } = props
 
    const [selectedChallengeId, setSelectedChallengeId] = useState('')
    const [mode, setMode] = useState("CHALLENGE"); // "CHALLENGE" | "IDEAS"
    const [dataFromChild, setDataFromChild] = useState([]);

    useEffect(() => {
        if (mode === 'CHALLENGE') {
            setSelectedChallengeId("");
        } else {
            setSelectedChallengeId("");
            setDataFromChild([])
        }
    }, [mode])

     useEffect(() => {
       	getInnovateChallengeFilterListFn('ACTIVE', 0, 400, true);
        // getIdeaListFromChallengeFn()	      }, []); // eslint-disable-line react-hooks/exhaustive-deps
    }, []);	
    
    // useEffect(() => {
    //     getInnovateChallengeAllListForRemoveEvaluatorFn()
    //     // getIdeaListFromChallengeFn()
    // }, []);


    useEffect(() => {

        const payloadIdeaList = {
            challengeKey: selectedChallengeId,
            userEmail
        }

        if(selectedChallengeId) {
            getIdeaListFromChallengeFn(payloadIdeaList)
        }
    }, [selectedChallengeId]);

  

    const handleChallengeSubmit = (e) => {
        // e.preventDefault();
        // console.log('Registration attempt:', formData);
        const payloadPass = {
            challengeKeyStr: dataFromChild, // challenge select multiple by Comma
            challengeKeyList: dataFromChild, // challenge select multiple List
            userEmail
        }
        deleteAssignedEvaluatorIntoChallengeFn(payloadPass)
        setSelectedChallengeId("");
        setDataFromChild([])

    };

    // 1. Callback function to receive the object
    const handleChildData = (childObject) => {
        setDataFromChild(childObject);
    };

    const handleSpecificIdeaChallengeSubmit = (e) => {
        const payloadPass = {
            challengeKey: selectedChallengeId,
            ideaKeys: dataFromChild,
            ideaKeysList: dataFromChild,
            userEmail
        }
        onDeteleSpecificIdeaListFromChallengeFn(payloadPass)

        // For challenge mode, just reset selection
        setSelectedChallengeId("");
        setDataFromChild([])

    };


    if (challengesListIsLoading) {
        return <Loading />;
    }

    return (

        <div className={classes.container}>

            <div className={classes.card}>

                <h2 style={{ marginBottom: '1rem' }}> Manage Evaluation Task  <span className='icon-info tooltip_v' >
                    <span title='This feature allows administrators to manage or remove Idea evaluators who are still pending for the selected challenge.' className='tooltiptext_v'> This feature allows administrators to manage or remove Idea evaluators who are still pending for the selected challenge. </span>
                </span> </h2>
                {/* <p>This feature allows administrators to manage or remove Idea evaluators who are still pending for the selected challenge.</p> */}

                <ModeToggle
                    mode={mode}
                    onChange={setMode}
                // disabled={submitting}
                />

                {(mode === "CHALLENGE") &&

                    <div className="auth-form">
                        <p><b>Select a Challenge </b></p>
                        {/* <div className="form-group">
                            <select
                                name="challengeId"
                                value={challengeId}
                                onChange={handleChange}
                                // onChange={(e) => onChange(e.target.value)}
                                required>
                                <option value="">Select Your Challenge</option>

                                {listInnovateChallengeForEvalutor?.data?.map((challengeItem) => (
                                    <option key={challengeItem.id} value={challengeItem.id}>
                                        {challengeItem.title}
                                    </option>
                                ))}

                            </select>
                        </div> */}

                        {/* <ChallengeSelect
                            challenges={listInnovateChallengeForEvalutor?.data}
                            value={selectedChallengeId}
                            onChange={setSelectedChallengeId}
                            loading={challengesListIsLoading}
                        // disabled={submitting}
                        /> */}

                                    <IdeaDropdownWithSearch
                                        dataList={listInnovateChallengeForEvalutor || []}
                                        sendDataToParent={handleChildData}
                                        mode='CHALLENGE'
                                    />

                        <button
                            type="button"
                            className='auth-button primary'
                            onClick={handleChallengeSubmit}
                            disabled={postAfterRemoveEvalutorIsLoading || 
                                !Array.isArray(dataFromChild) ||
                                dataFromChild?.length === 0
                            }
                        >
                            {postAfterRemoveEvalutorIsLoading ? " Loading... " : 'Submit'}
                        </button>
                    </div>

                }

                {mode === "IDEAS" && (

                    <div className="auth-form">

                        <div className="form-group">

                            <ChallengeSelect
                                challenges={listInnovateChallengeForEvalutor}
                                value={selectedChallengeId}
                                onChange={setSelectedChallengeId}
                                loading={challengesListIsLoading}
                            // disabled={submitting}
                            />

                            {/* <p>Select Challenge List </p>
                                <select
                                    name="challengeId"
                                    value={challengeId}
                                    onChange={handleChange}
                                    // onChange={(e) => onChange(e.target.value)}
                                    required>
                                    <option value="">Select Your Challenge</option>

                                    {listInnovateChallengeForEvalutor?.data?.map((challengeItem) => (
                                        <option key={challengeItem.id} value={challengeItem.id}>
                                            {challengeItem.title}
                                        </option>
                                    ))}

                                </select> */}
                        </div>

                        {
                            getListIdeaListRemoveEvalutorIsLoading ? 'Loading ...' : null
                        }
                        {
                            selectedChallengeId &&  (
                                <div className="form-group">
                                    <p>Choose Idea Lists </p>
                                    <IdeaDropdownWithSearch
                                        dataList={getInnovateIdeaListFromChallenge || []}
                                        sendDataToParent={handleChildData}
                                    />
                                </div>
                            )
                        }

                        <button
                            type="button"
                            className='auth-button primary'
                            onClick={handleSpecificIdeaChallengeSubmit}
                            disabled={
                                postAfterIdeaListRemoveEvalutorIsLoading ||
                                !Array.isArray(dataFromChild) ||
                                dataFromChild?.length === 0
                            }
                        >
                            {postAfterIdeaListRemoveEvalutorIsLoading ? " Loading... " : 'Submit'}
                        </button>
                    </div>

                )}
            </div>
        </div>

    )
}

export default AdminRemoveEvaluator